import type { WorkflowIssuesData } from '@atlassian/jira-business-board-workflow-issues/src/index.tsx';
import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { createResource, useResource } from '@atlassian/react-resource-router';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import fetchWorkflowIssues from './controllers/get-data/index.tsx';

const RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';

const resource = createResource<WorkflowIssuesData>({
	type: RESOURCE_TYPE_KEY,
	getKey: (matchedRoute) => {
		const { projectKey } = getProjectKeyId(matchedRoute.match, matchedRoute.query);
		return `${RESOURCE_TYPE_KEY}_${projectKey}_${matchedRoute.match?.params?.itemId ?? 'default'}`;
	},
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-business-workflows-prefetch", jiraSpaEntry: "async-business-common" */ './controllers/get-data'
		),
	getData: fetchWorkflowIssues,
	maxAge: 1000,
	isBrowserOnly: true,
});

export const useWorkflowIssues = () =>
	// forcing the return type due to react-resource-router's weird error types
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	useResource<WorkflowIssuesData>(workflowIssuesResource) as {
		data: WorkflowIssuesData | null | undefined;
		error: Error | null | undefined;
		loading: boolean;
	};

/**
 * @deprecated Delete resource when cleaning up board_harmonisation_m2
 */
export const workflowIssuesResource = resourceWithCondition(
	() => !expValEquals('board_harmonisation_m2', 'enabled', true, false),
	resource,
);
